class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.submitOnChange = this.dataset.submitOnChange || false;
    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[type="submit"]');
    this.cartNotification = document.querySelector('cart-mini');

    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

    this.makeSticky();
    this.errorHandling();
  }

  errorHandling() {

    const _this = this;

    const disabledButtons = document.querySelectorAll(`[data-disabled-action][form="${this.form.getAttribute("id")}"]`);

    disabledButtons.forEach((button) => {
      button.addEventListener('click', () => {
        _this.focusEmptySelects();
      });
    });
  }

  makeSticky() {

    const _this = this;

    if (this.dataset.makeSticky) {

      const observer = new IntersectionObserver(function (entries) {
        if (entries[0].boundingClientRect.bottom < 0) {
          // Element is visible in the screen
          _this.classList.add('is--sticky');
        } else {
          _this.classList.remove('is--sticky');
        }
      }, { threshold: [0] });

      const toObserve = document.querySelector(`variant-selects[data-form="${this.form.getAttribute("id")}"]`) || document.querySelector(`variant-radios[data-form="${this.form.getAttribute("id")}"]`);

      observer.observe(toObserve);

    }
  }

  errorNotices() {
    const errorNotices = Array.from(document.querySelectorAll(`error-notice[data-form="${this.form.getAttribute("id")}"]`));
    errorNotices.forEach((errorNotice) => {
      errorNotice.hasError();
    });
  }

  focusEmptySelects() {

    const selects = document.querySelectorAll(`select[form="${this.form.getAttribute("id")}"]`);
    let areEmpty = false;

    selects.forEach((select) => {

      const jsSelect = select.closest('.js-select')

      if (select.value === "" || select.value === undefined) {
        jsSelect.classList.add('animate');
        areEmpty = true;

        return;
      }
    });

    if (areEmpty) {
      const focusElement = document.querySelector(`variant-selects[data-form="${this.form.getAttribute("id")}"]`).offsetTop;
      const headerHeight = document.querySelector('.header.header--main').offsetHeight;
      const topPosition = focusElement - headerHeight;
      window.scrollTo({ top: topPosition, behavior: 'smooth' });
    }
  }

  onSubmitHandler(evt) {

    evt.preventDefault();

    this.cartNotification.setActiveElement(document.activeElement);

    const submitButtons = document.querySelectorAll(`[type="submit"][form="${this.form.getAttribute("id")}"]`);
    const discountCode = this.dataset.discountCode;

    submitButtons.forEach((submitButton) => {
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');
    });

    let applyDiscount = new Promise(function (resolve, reject) {
      if (discountCode) {
        document.cookie = `discount_code=${discountCode}; path=/`;
  
        // Send GET request to "/discount/[discountcode]"
        fetch(`/discount/${discountCode}`)
          .then((response) => {
            if (!response.ok) {
              reject(response.status);
            } else resolve(true);
          });
      } else {
        resolve(true);
      }
    });

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });


    applyDiscount.then(() => {

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          } else return response.json()
        })
        .then((parsedState) => {

          // Trigger a custom event on the document that passes the parsedState variable as a parameter
          let customEvent = new CustomEvent('theme:productAdded', { detail: parsedState });
          document.dispatchEvent(customEvent);

          this.cartNotification.getSectionInnerHTML();

          submitButtons.forEach((submitButton) => {
            submitButton.classList.add('added');
          });

          setTimeout(() => {

            submitButtons.forEach((submitButton) => {
              submitButton.classList.remove('added');
            });

            if (this.form.dataset.returnTo) {
              window.location.href = this.form.dataset.returnTo;
              return;
            }

            this.cartNotification.open();
          }, 2000);
        })
        .catch((e) => {
          console.error(e);
          this.errorNotices();
        })
        .finally(() => {

          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('disabled');
          });

          fetch(`${routes.cart_url}`, { ...fetchConfig('javascript'), body })
            .then((response) => {
              if (!response.ok) {
                throw new Error(response.status);
              } else return response.json()
            })
            .then((parsedState) => {

              console.log('theme:cartUpdated fetch');

              // Trigger a custom event on the document that passes the parsedState variable as a parameter
              let cartUpdated = new CustomEvent('theme:cartUpdated', { detail: parsedState });
              document.dispatchEvent(cartUpdated);
            });
        });
    });
  }
}

customElements.define('product-form', ProductForm);


